import { render } from "./AccessibleEnvironmentTable.vue?vue&type=template&id=60126ec3&scoped=true"
import script from "./AccessibleEnvironmentTable.vue?vue&type=script&lang=js"
export * from "./AccessibleEnvironmentTable.vue?vue&type=script&lang=js"

import "./AccessibleEnvironmentTable.vue?vue&type=style&index=0&id=60126ec3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60126ec3"]])

export default __exports__